import React from 'react'
import { Sidetab } from '@typeform/embed-react'

export default function TypeSidetab({id, buttonText, buttonColor}) {
    return <Sidetab id={id} buttonText={buttonText} buttonColor={buttonColor}/>
}